module.exports = __webpack_public_path__ + "static/media/stars-medal-grey.be009517.svg";